import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';

@Component({
	selector: 'app-offline',
	standalone: true,
	imports: [CommonModule, IonicModule],
	templateUrl: './offline.component.html',
	styleUrls: ['./offline.component.scss']
})
export class OfflineComponent implements OnInit 
{
	offline: boolean = false;
	ngOnInit() {
		this.offline = !navigator.onLine;
		window.addEventListener('online', () => {
			this.offline = false;
		});
		window.addEventListener('offline', () => {
			this.offline = true;
		});
	}

	retry()
	{
		// Simple full reload attempt; could be replaced by a config refresh service call
		location.reload();
	}
}
